import { render } from "./ButtonAddInscription.vue?vue&type=template&id=c3b645ce&scoped=true"
import script from "./ButtonAddInscription.vue?vue&type=script&lang=js"
export * from "./ButtonAddInscription.vue?vue&type=script&lang=js"

import "./ButtonAddInscription.vue?vue&type=style&index=0&id=c3b645ce&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b645ce"]])

export default __exports__